<div
    class='agpr-tabs'
    [ngClass]="{
        'agpr-tabsStretch': style === tabsStyleTypesEnum.icon,
    }"
>
    <ul
        *ngIf="tabs?.length > 0"
        class="agpr-tabs-tabsGroup"
        [ngClass]="{
            'agpr-tabs-tabsGroupStretch': style === tabsStyleTypesEnum.icon,
            'agpr-tabs-tabsGroup-removeSpacing': !isCardView,
        }"
        role="tablist"
        [attr.aria-orientation]="orientation"
        (keyup)="onKeyUp($event)"
    >
        <div
            #tabLine
            class="agpr-tabListLine agpr-tabListLine-leftVertical"
            [ngClass]="{
                'agpr-tabsStretch': style === tabsStyleTypesEnum.icon,
            }"
        ></div>
        <ng-container
            *ngFor="let tab of tabs"
        >
            <li
                class="agpr-tabs-tab agpr-tabs-tab-leftVertical"
                [ngClass]="{
                    'agpr-tabs-tab--selected': tab.selected,
                    'agpr-tabs-tab--disabled': tab.disabled,
                    'agpr-tabs-tabStretch': style === tabsStyleTypesEnum.icon,
                    'agpr-tabs-tab--spacer spacerTab': tab.showSpacer && !tab.hideTabShowContent,
                    'agpr-tabs-tab-noHeightWidth': tab.hideTabShowContent,
                    'agpr-tabs-tab-card': isCardView,
                    'agpr-tabs-tab-removeSpacing': !isCardView,
                }"
                [id]="tab.id"
                (click)="selectTab(tab)"
                role="tab"
                [attr.aria-controls]="tab.id + '.panel'"
                [attr.aria-selected]="tab.selected ? true : false"
            >
                <ng-container>
                    <span
                        *ngIf="tab.icon"
                        class="agpr-tabs-tabIcon"
                        [ngClass]="tab.icon"
                        aria-hidden="true"
                        [pTooltip]="(tab.tooltip && !isCardView) ? (tab.tooltip | localize) : ''"
                        tooltipPosition="right"
                    ></span>
                    <div
                        class="agpr-tabs-heading"
                        [ngClass]="{
                            'agpr-tabs-tabStretchHeading--selected': tab.selected,
                            'agpr-tabs-tabStretchHeading': style === tabsStyleTypesEnum.icon,
                            'agpr-tabs-hide': !isCardView,
                        }"
                        role="heading"
                        [attr.aria-level]="tabsHeadingLevel"
                    >
                        {{ tab.heading | localize }}
                    </div>
                    @if(tab?.description) {
                        <div
                            class="agpr-tabs-description"
                            [ngClass]="{
                                'agpr-tabs-hide': !isCardView,
                            }"
                            role="desicription"
                            [attr.aria-level]="tabsHeadingLevel+1"
                        >
                            {{ tab.description | localize }}
                        </div>
                    }
                </ng-container>
            </li>
        </ng-container>
    </ul>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
    <div
        *ngIf="(!tabs || tabs.length < 1 || _selectedTabIndex !== null) && useContentContainer"
        class="agpr-tabs-contents"
    >
        <div
            *ngIf="tabHeader"
            class="agpr-tabs-header"
        >
            <ng-container *ngTemplateOutlet="tabHeader"></ng-container>
        </div>
        <agpr-scroll-panel #scrollPanel>
            <ng-content></ng-content>
        </agpr-scroll-panel>
        <ng-content select="[noScrollPanelContent]"></ng-content>
    </div>
</div>
